export const iff = (condition, then, otherwise) =>
  condition ? then : otherwise;
